import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import BlockImage from "../Block/BlockImage";
import BlockButton from "../Block/BlockButton";
import Block from "../Block/Block";
import { useNavigate } from 'react-router-dom';
import GalleryArea from "./GalleryArea";

function Gallery() {
  const navigate = useNavigate();
  return (
    <div>
      <Header/>      

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%" textAlign="center" color="grey" fontStyle="italic">
          <BlockTitle fontSize="25px" fontWeight="normal">Paintings and Drawings</BlockTitle>
        </BlockContent>
        <BlockContent width="100%" textAlign="center" color="grey" fontStyle="italic">
          <BlockText>In my spare time, I enjoy drawing and painting. The works below are studies based on existing artworks.</BlockText>
        </BlockContent>
      </Block>

      <GalleryArea/>
      <Footer/>
    </div>
  );
}

export default Gallery;
